import { Link } from 'react-router-dom'

export function ProcurementStatusBar() {
  return (
    <div className="bg-white rounded-2xl border border-gray-200 px-4 py-2.5 flex items-center justify-end flex-wrap gap-2">
      <Link
        to="/procurement/queue"
        className="px-3 py-1 text-xs rounded-lg border border-gray-200 bg-white text-gray-700 hover:bg-gray-50"
      >
        Скачать запрос
      </Link>
      <Link
        to="/procurement/queue"
        className="px-3 py-1 text-xs rounded-lg bg-gray-900 text-white hover:bg-gray-800"
      >
        Загрузить ответ
      </Link>
    </div>
  )
}
